import { useQuery } from "@tanstack/react-query";
import { NotifyService } from "../../../services/notify/notify-service";
import { useMemo } from "react";
import { useUser } from "../../../hook/use-user";

export const useNotfiy = () => {
  const { email } = useUser();
  const currentUrl = window.location.href.search("document");

  const { data, isLoading } = useQuery({
    queryKey: ["notify"],
    queryFn: () => NotifyService.getNotify(),
    enabled: currentUrl > 0,
  });

  const notifyToMeData = useMemo(() => {
    return data?.data
      ?.filter((e: any) => e.notifyTo?.includes(email?.toLowerCase()))
      .sort((a: any, b: any) => b.id - a.id);
  }, [data?.data, email]);

  const firstItem = useMemo(() => notifyToMeData?.at(0), [notifyToMeData]);

  const countNotifyToMeData = useMemo(() => notifyToMeData?.filter((e: any) => !e.viewed).length, [notifyToMeData]);

  return { data, isLoading, countNotifyToMeData, notifyToMeData, firstItem };
};
